import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import ExtraAudioUploadModal from './ExtraAudioUploadModal';
import { API } from "../../utils/amplifyWrapper";
import * as Sentry from '@sentry/react';
import { toast } from 'react-toastify';
import Spinner from '../Spinner';
import Info from '../Info';
import { Card } from '../ui/bootstrap';
import PlayerPreviewIcon from '../../assets/play.svg';
import EditIcon from '../../assets/edit-icon.svg';
import UploadIcon from '../../assets/upload.svg';
import DeleteIcon from '../../assets/trash.svg';

function ExtraAudiosUpload({ orgId, integrationId, integration, onPlay }) {
    const [showUploadAudio, setShowUploadAudio] = useState();
    const [selectedAudio, setSelectedAudio] = useState(null);
    const [audioKey, setAudioKey] = useState(null);
    const [isAudioDeleting, setIsAudioDeleting] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false)

    const onDeleteAudio = async () => {
        setIsAudioDeleting(true)
        try {

            await API.put('main', `/organisation/${orgId}/integration/${integrationId}/extraaudio?key=${audioKey}`, {
                headers: { "Content-Type": "application/json" }
            })

        } catch (e) {

            toast.error("Something went wrong while deleting audio.")
            Sentry.captureException(e);

        } finally {
            setIsAudioDeleting(false)
            setShowConfirmation(false)
            window.location = window.location.href
        }
    }

    return (
        <Card className="p-4 mt-4" shadow>
            <div className="mb-3">
                <label>Pre Audio <Info text="Pre Audio is played before the actual content" /></label>
                <div className="float-end">
                    {integration.pre_audio_url ?
                        <button type="button" className="btn btn-sm small-button me-1"
                            title="Play Audio"
                            onClick={() => {
                                onPlay(integration.pre_audio_url);
                            }}><img style={{ height: "20px" }} src={PlayerPreviewIcon} /></button> : null}

                    <button type="button" className="btn btn-sm small-button mx-1"
                        title={integration.pre_audio_url ? "Edit your uploaded audio" : "Upload a new audio"}
                        onClick={() => {
                            setShowUploadAudio(true);
                            setSelectedAudio(integration.pre_audio_url);
                            setAudioKey("pre_audio_url")
                        }}>
                        <img style={{ height: "20px" }} src={integration.pre_audio_url ? EditIcon : UploadIcon} />
                    </button>

                    {
                        integration.pre_audio_url ?
                            <button title="Delete an already uploaded audio" type="button" className="btn btn-sm small-button text-center mx-1" onClick={() => {
                                setAudioKey("pre_audio_url"); setShowConfirmation(true);
                            }}>
                                <img style={{ height: "20px" }} src={DeleteIcon} />
                            </button> : null
                    }

                </div>
            </div>
            <div className="mb-3">
                <label>Post Audio <Info text="Post Audio is played after the actual content" /></label>

                <div className="float-end">
                    {integration.post_audio_url ?
                        <button type="button" className="btn btn-sm small-button me-1"
                            title="Play Audio"
                            onClick={() => {
                                onPlay(integration.post_audio_url);
                            }}><img style={{ height: "20px" }} src={PlayerPreviewIcon} /></button> : null}

                    <button type="button" className="btn btn-sm small-button mx-1"
                        title={integration.post_audio_url ? "Edit your uploaded audio" : "Upload a new audio"}
                        onClick={() => {
                            setShowUploadAudio(true);
                            setSelectedAudio(integration.post_audio_url);
                            setAudioKey("post_audio_url")
                        }}>
                        <img style={{ height: "20px" }} src={integration.post_audio_url ? EditIcon : UploadIcon} />
                    </button>

                    {
                        integration.post_audio_url ?
                            <button title="Delete an already uploaded audio" type="button" className="btn btn-sm small-button text-center mx-1" onClick={() => {
                                setAudioKey("post_audio_url"); setShowConfirmation(true);
                            }}>
                                <img style={{ height: "20px" }} src={DeleteIcon} />
                            </button> : null
                    }


                </div>
            </div>
            <div className="mb-3">
                <label>Background Audio <Info text="Background Audio is played with the actual content in background" /></label>
                <div className="float-end">
                    {integration.background_audio_url ?
                        <button type="button" className="btn btn-sm small-button me-1"
                            title="Play Audio"
                            onClick={() => {
                                onPlay(integration.background_audio_url);
                            }}><img style={{ height: "20px" }} src={PlayerPreviewIcon} /></button> : null}

                    <button type="button" className="btn btn-sm small-button mx-1"
                        title={integration.background_audio_url ? "Edit your uploaded audio" : "Upload a new audio"}
                        onClick={() => {
                            setShowUploadAudio(true);
                            setSelectedAudio(integration.background_audio_url);
                            setAudioKey("background_audio_url")
                        }}>
                        <img style={{ height: "20px" }} src={integration.background_audio_url ? EditIcon : UploadIcon} />
                    </button>

                    {
                        integration.background_audio_url ?
                            <button title="Delete an already uploaded audio" type="button" className="btn btn-sm small-button text-center mx-1" onClick={() => {
                                setAudioKey("background_audio_url");
                                setShowConfirmation(true);
                            }}>
                                <img style={{ height: "20px" }} src={DeleteIcon} />
                            </button> : null
                    }

                </div>
            </div>
            <ExtraAudioUploadModal
                orgId={orgId}
                integrationId={integrationId}
                audioKey={audioKey}
                show={showUploadAudio}
                selectedAudio={selectedAudio}
                onSuccess={() => {
                    setSelectedAudio(null);
                    window.location = window.location.href
                }} onHide={() => {
                    setShowUploadAudio(false);
                    setSelectedAudio(null)
                }}
            />

            <Modal show={showConfirmation} onHide={() => { setShowConfirmation(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Audio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete this audio?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline-primary me-3" onClick={() => setShowConfirmation(false)}>Cancel</button>
                    {
                        (isAudioDeleting) ?
                            (
                                <button type="button" className="btn btn-danger text-center">
                                    <Spinner color="white" />
                                </button>
                            )
                            :
                            (
                                <button type="button" className="btn btn-danger" onClick={() => onDeleteAudio()}>Delete</button>
                            )
                    }
                </Modal.Footer>
            </Modal>
        </Card>
    );
}

export default ExtraAudiosUpload;
